import clsx from "clsx";
import Link from "next/link";

import Button from "../button";
import LocationListItem from "../location-list-item";

import styles from "./featured-locations-section.module.scss";

const FeaturedLocationsSection = ({ locations = [] }) => {

  return (
    <div className={styles.FeaturedLocationsSection}>
      <div className={clsx("container", styles.Wrapper)}>
        <div className={styles.Content}>
          <h3> Featured Locations</h3>
          <p>Explore our available locations</p>

          <Link href="/locations" passHref>
            <Button outline small rounded className={styles.DesktopButton}>
              View All Locations
            </Button>
          </Link>
        </div>
        <div className={styles.LocationsList}>
          {locations.map((location) => (
            <LocationListItem
              key={location.slug}
              location={location}
              showBrochure
            />
          ))}
        </div>

        <div className={styles.MobileButton}>
          <Link href="/locations" passHref>
            <Button outline small rounded>
              View All Locations
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedLocationsSection;
